import pickBy from "lodash/pickBy";
import { getVisibleProperties } from "PFCore/helpers/templates";
import { Activity, Subtemplate, Template } from "PFTypes";
import { useCallback, useMemo } from "react";

type UseGetCustomFieldsToLink = {
  template: Template;
  parentTemplate: Template | undefined;
};

export const useGetCustomFieldsToLink = ({ template, parentTemplate }: UseGetCustomFieldsToLink) => {
  const linkableCustomFieldKeys = useMemo(
    () =>
      Object.keys(
        pickBy<Template["schema"]["properties"]>(
          parentTemplate?.schema?.properties,
          (property) => property.linked_from_engagement
        )
      ),
    [parentTemplate]
  );

  return useCallback(
    ({ engagement, roleSubtemplate }: { engagement: Activity; roleSubtemplate: Subtemplate | null }) =>
      engagement.custom_fields.filter(
        (customField) =>
          linkableCustomFieldKeys.includes(customField.type.name) &&
          !!getVisibleProperties(roleSubtemplate || template).find(
            ({ type, name }) => type === "custom_field" && name === customField.type.name
          )
      ),
    [linkableCustomFieldKeys, template]
  );
};
